const notices = (notices = [], action) => {
  switch (action.type) {
    case 'FETCH_NOTICES':
      return action.payload
    default:
      return notices
  }
}
export default notices
